<div class="modal-header">
    <h4 class="modal-title">Are you sure job is completed? (This action cannot be undone)</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
  
  <div class="modal-body">
    <div class="d-flex w-100 justify-content-center" style="gap: 5px">
        <button class="btn btn-success" (click)="jobIsComplete()">Yes job is complete</button>
        <button class="btn btn-danger" (click)="jobNotComplete()">No Job is not complete</button>

    </div>
 
  </div>
